import React from 'react';

/**
 * Explains a failed WebAPI call (see webAPICall) in the same way for every
 * feature: what went wrong, that the rest of Chronos is unaffected so nobody
 * thinks they must stop work, what to try, and the technical detail to hand
 * for whoever they report it to.
 * @param {Error}  error   from webAPICall: message for the user, detail for support
 * @param {string} [impact] what the failure does and doesn't affect, for this feature
 */
const WebAPIProblem = ({ error, impact = 'The rest of Chronos works as normal.' }) =>
    <div className='webapi-problem'>
        <p><strong>{error.message}</strong></p>
        <p>{impact}</p>
        {'unreachable' === error.kind &&
            <p>
                If you're working away from the office, connect to the IPRS
                network and try again.
            </p>}
        <p>If it keeps happening, report it to IT with the technical details below.</p>
        {error.detail &&
            <details>
                <summary>Technical details</summary>
                <code>{error.detail}</code>
            </details>}
    </div>;

export default WebAPIProblem;
